import CoreApi from '../../api/CoreApi';
import { config } from '../../../config';
import { createQueryFn, QueryNameSpace } from '../../lib/query';

/**
 * Verejné správy aplikácie. Bez tokenu, takže funguje aj pre neprihláseného
 * návštevníka - a práve to je pointa: banner s oznámením o odstávke musí byť
 * čitateľný, aj keď sa nikto nedokáže prihlásiť.
 */
export const publicGetClientMessages = createQueryFn(
  QueryNameSpace.publicGetClientMessages,
  async () => await CoreApi.publicGetClientMessages(config.CLIENT_ID),
);
